import {
  AUTO_TIEOUT_COMPARE_MODE,
  AUTO_TIEOUT_COMPARE_MODE_FAILED,
  AUTO_TIEOUT_COMPARE_MODE_INPROGRESS,
  AUTO_TIEOUT_COMPARE_MODE_NEW,
  AUTO_TIEOUT_COMPARE_MODE_SUCCESS,
  SIDE_BY_SIDE_CARRYOVER,
  SIDE_BY_SIDE_COMPARE_MODE,
  SIDE_BY_SIDE_ORIGINAL,
  TRAIL_BALANCE_MODE,
} from 'constants/feature/statement-content-constants';
import ApiModel from 'models/api-model';
import { isNullOrUndefined } from 'utils/object-utils';

export default class AutoTieoutWorkflowData extends ApiModel({
  data: {
    workflowId: null, // workflowId
    workpaperId: null,
    sourceClientId: null, //4024,
    sourceStatementId: null, //7773,
    sourceRevisionId: null, //8013,
    targetClientId: null, //4024,
    targetStatementId: null, //7774,
    targetRevisionId: null, //8014,
    startTime: '', //'2025-10-27T08:25:16Z',
    retryCount: 0,
    maxRetries: 0,
    retryable: true,
    errorCode: null,
    errorInfo: null,
    initiatorId: null, // userId
    workflowType: null,
    status: '', //  'IN_PROGRESS',
    reportGuid: null,
    keyVersion: null,
    origin: null,
    valueThreshold: null,
  },
}) {
  processResponse(response) {
    return { data: { ...response.data } };
  }

  // used to check whether the statement is already linked in the workflow or not when selecting linked statements from the list
  // with this id
  isItLinkedAlready(id) {
    return this.data.workflowId === id;
  }

  get workFlowData() {
    return this.data;
  }

  get workflowId() {
    return this.data?.workflowId;
  }

  get isSideBySideMode() {
    return this.data?.workflowType === SIDE_BY_SIDE_COMPARE_MODE;
  }

  get isTrailBalanceMode() {
    return this.data?.workflowType === TRAIL_BALANCE_MODE;
  }

  get isAutoTieoutMode() {
    return this.data?.workflowType === AUTO_TIEOUT_COMPARE_MODE;
  }

  get isWorkflowInProgress() {
    return (
      this.data?.status === AUTO_TIEOUT_COMPARE_MODE_INPROGRESS ||
      this.data?.status === AUTO_TIEOUT_COMPARE_MODE_NEW
    );
  }

  get isWorkflowFailed() {
    return this.data?.status === AUTO_TIEOUT_COMPARE_MODE_FAILED;
  }

  get isOriginMissing() {
    return isNullOrUndefined(this.data?.origin);
  }

  get isOriginOriginal() {
    return this.data?.origin === SIDE_BY_SIDE_ORIGINAL;
  }

  get isOriginCarryover() {
    return this.data?.origin === SIDE_BY_SIDE_CARRYOVER;
  }

  get workpaperId() {
    return this.data?.workpaperId;
  }

  get workflowStatus() {
    return this.data?.status;
  }

  get workflowType() {
    return this.data?.workflowType;
  }

  get isRetryable() {
    return this.data?.retryable;
  }

  get maxRetries() {
    return this.data?.maxRetries || 0;
  }

  get retryCount() {
    return this.data?.retryCount;
  }

  get isCompleted() {
    return this.data?.status === AUTO_TIEOUT_COMPARE_MODE_SUCCESS;
  }

  get getSourceStatementsData() {
    return {
      clientId: this.data?.sourceClientId,
      statementId: this.data?.sourceStatementId,
      revisionId: this.data?.sourceRevisionId,
    };
  }

  get getTargetStatementsData() {
    return {
      clientId: this.data?.targetClientId,
      statementId: this.data?.targetStatementId,
      revisionId: this.data?.targetRevisionId,
    };
  }

  get threshold() {
    return this.data?.valueThreshold;
  }
}
